import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function GoogleCallback() {
  const navigate = useNavigate();
  const processedRef = useRef(false); // prevent duplicate calls

  useEffect(() => {
    if (processedRef.current) return; // skip if already run
    processedRef.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (code) {
      axios
        .get(`${BASE_URL}/api/auth/google/callback/?code=${code}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
          },
        })
        .then(() => {
          toast.success("Gmail connected successfully!");
          // use replace to avoid back navigation to callback
          navigate("/user-dashboard/settings", { replace: true });
        })
        .catch((err) => {
          console.error("Error connecting Gmail:", err);
          toast.error("Failed to connect Gmail.");
          navigate("/user-dashboard/settings", { replace: true });
        });
    } else {
      toast.error("Missing Google authorization code.");
      navigate("/user-dashboard/settings", { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <p>Connecting your Email...</p>
    </>
  );
}
